import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { BomLineGroupsDataGrid } from "src/components/views/erp/productDesign/masterData/bomLineGroups/BomLineGroupsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productDesign/bomLineGroups")({
	staticData: { title: i18n.t("bom_line_groups"), legacyViewKey: "bomLineGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <BomLineGroupsDataGrid />;
}
